export enum eDetailsView { Info, Map };